import { object } from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { updateMissionFormObject, updateMissions } from '@store/slice/missionSlice'
import { updateNotification } from '@store/slice/mainSlice'
import { useNavigate } from 'react-router'
import Buttons from '@ui/elements/Buttons'
import Div from '@ui/layout/Div'
import Image from '@ui/elements/Image'
import Span from '@ui/elements/Span'
import Icon from '@ui/elements/Icon'
import DeleteButton from '@ui/elements/DeleteButton'
import { ROLE_SUPER_ADMIN } from '@router/Routes'
import { get } from '@util/xhrAPI'

const MissionVign = ({ mission }) => {
  const { missions } = useSelector(state => state.mission)
  const { missionLogo, missionTitle, createdAt, missionUrl, billingType, city, mairie, id } = mission
  const [t] = useTranslation('mission')
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const goToMissionForm = () => {
    if (dispatch(updateMissionFormObject({
      ...mission,
      city: city.id,
      mairie: mairie.id,
      billingType: billingType ? billingType.id : null
    }))) {
      navigate(ROLE_SUPER_ADMIN['createMission'])
    }
  }

  const removeMission = () => {
    get(`${import.meta.env.VITE_API_URL}/api/missions/remove/${id}`, response => {
      const { code } = response
      if (code == 200) {
        const missionsList = { ...missions }
        delete missionsList[id]
        dispatch(updateNotification({ type: 'is-success', message: t('messages.removed_successfuly', { title: missionTitle }) }))
        dispatch(updateMissions({ ...missionsList }))
      } else {
        dispatch(updateNotification({ type: 'is-danger', message: t('messages.error_occured') }))
      }
    })
  }

  const getDeleteButtons = id => {
    return [
      {
        icon: 'icon-done',
        text: t('actions.validate'),
        callback: removeMission,
        cssClass: 'is-danger',
        parameter: id
      },
      {
        icon: 'icon-keyboard_arrow_left',
        text: t('actions.cancel'),
        cssClass: 'is-success'
      }
    ]
  }

  return (
    <Div cssClass='column is-4'>
      <Div cssClass='mission-vign'>
        <Image src={missionLogo} />
        <Div cssClass='mission-details'>
          <Span text={missionTitle} cssClass='mission-title' />
          <Span>
            <Icon icon='icon-map' />
            {city.name}
          </Span>
          <Span>
            <Icon icon='icon-calendar' />
            {createdAt}
          </Span>
          <Span>
            <Icon icon='icon-link' />
            {missionUrl}
          </Span>
          <Div cssClass='actions'>
            <Buttons
              buttons={[
                { cssClass: 'update-mission is-info is-small', icon: 'icon-create', callback: goToMissionForm, text: t('actions.go_to_mission_form') }
              ]}
            />

            <DeleteButton
              buttons={getDeleteButtons(id)}
              message={t('messages.confirm_item_deletion', { element: missionTitle })}
              label={t('actions.remove_mission')}
            />
          </Div>
        </Div>
      </Div>
    </Div>
  )
}

MissionVign.propTypes = {
  mission: object
}

export default MissionVign